/* ==========================================================================
 * Build Your Set - Etoile
 * RNR Digital Media Group
 *
 * Selection engine for sections/build-your-set.liquid. No framework.
 *
 * DESIGN NOTES
 *
 * Selections are a FLAT ARRAY, not a map keyed by variant. Adding the same
 * case four times gives four rows, each independently removable and
 * monogrammable. The old BYOB panel grouped by variant id, so a second add
 * raised the price but never appeared - the bug reported on 03 Sep.
 *
 * Every selection goes to the cart as its OWN line with quantity 1, carrying
 * _set_index. Shopify would otherwise merge identical variants into one line
 * of quantity 2 and the cart would stop agreeing with the panel.
 *
 * MONOGRAM PROPERTIES GO ON THE PRODUCT LINE, not on the charge line. That
 * is what the bundle PDP does, and snippets/cart-line-items.liquid is built
 * around it: it hides every Personalisation-type line, and renders
 * "+ Monogram / Monogram Letters / Colour" from any line that carries a
 * Personalisation property. Putting them here means the cart matches the
 * PDP exactly with no change to that snippet.
 *
 * _set_id ties a set together AND is what the discount Function gates on, so
 * the tier percentage can never reach the same products bought individually.
 * Underscore-prefixed, so Shopify hides it from the customer.
 *
 * NOTHING HERE APPLIES A DISCOUNT. The panel previews the tier price; the
 * money is decided by the Function at checkout. If the two ever disagree,
 * the Function is right and this is the bug.
 * ========================================================================== */

(function () {
  'use strict';

  var root = document.querySelector('[data-bys]');
  if (!root) return;

  var cfgEl = root.querySelector('[data-bys-config]');
  var cfg;
  try {
    cfg = JSON.parse(cfgEl.textContent);
  } catch (e) {
    console.warn('[BYS] config failed to parse', e);
    return;
  }

  var GRID_IMAGE_WIDTH = 692;   /* 346 CSS px at 2x */

  var variantsById = {};
  (cfg.products || []).forEach(function (p) {
    (p.variants || []).forEach(function (v) {
      variantsById[String(v.id)] = { variant: v, product: p };
    });
  });

  var tiers = (cfg.tiers || []).slice().sort(function (a, b) { return a.quantity - b.quantity; });

  /* ---------------------------------------------------------------- state */
  var selections = [];
  var pickedTierId = null;
  var openColourUid = null;
  var openMonoUid = null;
  var openFoilUid = null;
  var submitting = false;
  var uidSeq = 0;

  var tiersEl  = root.querySelector('[data-bys-tiers]');
  var blocksEl = root.querySelector('[data-bys-blocks]');
  var subEl    = root.querySelector('[data-bys-subheading]');
  var ctaEl    = root.querySelector('[data-bys-checkout]');

  /* --------------------------------------------------------------- helpers */
  /* Variant images are emitted at width=140 for the panel thumbnails. The
     grid needs 692. Shopify's image_url writes "?width=140", NOT the legacy
     "_140x" filename form - matching the wrong one left the grid showing a
     140px image stretched to 346px, which is why colours looked blurred
     after selection. Both forms are handled. */
  function upscale(url, width) {
    if (!url) return '';
    var out = String(url);
    if (/[?&]width=\d+/.test(out)) return out.replace(/([?&]width=)\d+/, '$1' + width);
    if (/_\d+x(\.|_|$)/.test(out)) return out.replace(/_\d+x/, '_' + width + 'x');
    return out;
  }

  function money(cents) {
    var amount = (cents || 0) / 100;
    var out;
    try {
      out = new Intl.NumberFormat('en', {
        style: 'currency',
        currency: cfg.currency || 'AUD',
        currencyDisplay: 'narrowSymbol'
      }).format(amount);
    } catch (e) {
      out = amount.toFixed(2);
    }
    return out.replace(/[.,]00$/, '');
  }

  function foilsAll() {
    return (window.monogram_colors || [
      { title: 'Silver', colour: '#c1c1c1' },
      { title: 'Gold', colour: '#caaa45' },
      { title: 'Blind (no colour)', colour: '' }
    ]).filter(function (f) { return /^(gold|silver)$/i.test(f.title.trim()); });
  }
  function fontName() {
    var f = window.monogram_font_faces;
    return ((f && f[0] && f[0].title) || 'Serif').toLowerCase();
  }
  function sizeName() {
    var s = window.monogram_font_sizes;
    return ((s && s[0] && s[0].title) || '36PT').toLowerCase();
  }
  function foilValue(f) {
    return (f && f.colour) ? f.title.toLowerCase() : 'blind';
  }
  function foilLabel(f) {
    return f.title.replace(/\s*\(no colour\)\s*/i, '').trim() || f.title;
  }
  function foilsFor(variantId) {
    /* Both foils are selectable in Build Your Set. Hardware guides the
       recommendation and warning; product eligibility is checked separately. */
    return foilsAll();
  }
  function letterLimit(variantId) {
    var rec = variantsById[String(variantId)];
    return (rec && parseInt(rec.variant.letterLimit, 10)) || 3;
  }
  function canMonogram(variantId) {
    var rec = variantsById[String(variantId)];
    return !!(rec && rec.product.monogram && cfg.monogram.available && foilsFor(variantId).length);
  }
  function el(tag, cls, text) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text != null) n.textContent = text;
    return n;
  }

  /* ----------------------------------------------------------------- tiers */
  function reachedTier() {
    var n = selections.length, found = null;
    tiers.forEach(function (t) {
      if (n >= parseInt(t.quantity, 10)) found = t;
    });
    return found;
  }
  function pickedTier() {
    if (!pickedTierId) return null;
    return tiers.filter(function (t) { return t.id === pickedTierId; })[0] || null;
  }
  function activeTier() {
    return pickedTier() || reachedTier() || tiers[0] || null;
  }

  /* How many blocks the panel shows in total. Empty "Select Your Product"
     slots are the difference between this and what has been selected.

     Once a tier is MET the set is complete, so the target is simply what the
     shopper has chosen - no ghost slot. Aiming at the next unreached tier
     here meant hitting 3 items immediately asked for a 4th, which reads as
     "you are not finished" when they are.

     A tab the shopper clicked still sets the goal, so they can deliberately
     work toward 4 or 5 and see the slots to fill. */
  function targetQty() {
    var picked = pickedTier();
    if (picked) return parseInt(picked.quantity, 10) || selections.length;

    var n = selections.length;
    if (reachedTier()) return n;

    var next = tiers.filter(function (t) { return n < parseInt(t.quantity, 10); })[0];
    return next ? parseInt(next.quantity, 10) : n;
  }

  function tierLabel(t) {
    return t.quantity + (t.open ? '+' : '') + ' items for ' + t.percent + '% off';
  }

  /* ---------------------------------------------------------------- prices */
  function productsSubtotal() {
    return selections.reduce(function (sum, s) {
      var rec = variantsById[String(s.variantId)];
      return sum + (rec ? rec.variant.price : 0);
    }, 0);
  }
  function monogramTotal() {
    var n = selections.filter(function (s) { return s.monogram; }).length;
    return n * (cfg.monogram.price || 0);
  }
  /* Monogramming is a separate add-on product - never discounted. */
  function rrpTotal() { return productsSubtotal() + monogramTotal(); }
  function discountedTotal() {
    var t = reachedTier();
    if (!t) return rrpTotal();
    var off = Math.round(productsSubtotal() * (parseFloat(t.percent) / 100));
    return (productsSubtotal() - off) + monogramTotal();
  }

  function initCollectionMedia() {
    var sections = window.Shopify && Shopify.theme && Shopify.theme.sections;
    var registration = sections && sections.registered['featured-collection'];
    if (!registration || !registration.components[0]) return;
    registration.components[0].onLoad.call({ id: root.closest('section').id + '-media', container: root.querySelector('[data-bys-grid]') });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initCollectionMedia, { once: true });
  else initCollectionMedia();

  /* ================================================================== GRID */
  root.querySelectorAll('[data-bys-card]').forEach(function (card) {
    var strip = card.querySelector('[data-bys-swatches]');
    var toggle = card.querySelector('[data-bys-swatch-toggle]');

    function closeColours() {
      if (!strip || !toggle) return;
      strip.hidden = true;
      toggle.setAttribute('aria-expanded', 'false');
      toggle.textContent = toggle.getAttribute('data-label-open');
    }

    if (toggle && strip) {
      toggle.addEventListener('click', function (e) {
        e.stopPropagation();
        var open = strip.hidden;
        root.querySelectorAll('[data-bys-swatch-toggle][aria-expanded="true"]').forEach(function (other) {
          if (other !== toggle) other.click();
        });
        strip.hidden = !open;
        toggle.setAttribute('aria-expanded', String(open));
        toggle.textContent = toggle.getAttribute(open ? 'data-label-close' : 'data-label-open');
      });
      document.addEventListener('click', function (e) {
        if (!card.contains(e.target)) closeColours();
      });
      card.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && !strip.hidden) {
          closeColours();
          toggle.focus();
        }
      });
    }

    card.querySelectorAll('[data-bys-swatch]').forEach(function (sw) {
      sw.addEventListener('click', function (e) {
        e.stopPropagation();
        if (sw.disabled) return;
        var vid = sw.getAttribute('data-variant-id');
        var rec = variantsById[String(vid)];
        if (!rec || !rec.variant.available) return;

        card.setAttribute('data-variant-id', vid);
        card.querySelectorAll('[data-bys-swatch]').forEach(function (o) {
          o.classList.toggle('is-selected', o === sw);
          o.setAttribute('aria-pressed', String(o === sw));
        });

        var img = card.querySelector('[data-bys-image]');
        if (img && rec.variant.image) img.src = upscale(rec.variant.image, GRID_IMAGE_WIDTH);
        var nativeMedia = card.querySelector('.bys-card__native-media');
        if (nativeMedia) {
          nativeMedia.querySelectorAll('[data-product-media-slideshow][data-variant]').forEach(function (slider) {
            var selected = slider.getAttribute('data-variant') === String(vid);
            slider.classList.toggle('hidden', !selected);
            if (selected) {
              var instance = window.themeVendor && themeVendor.Flickity.data(slider);
              if (instance) { instance.resize(); instance.select(0, false, true); }
            }
          });
          nativeMedia.querySelectorAll('[data-grid-link]').forEach(function (link) {
            var url = new URL(link.href); url.searchParams.set('variant', vid); link.href = url.href;
          });
        }
        var name = card.querySelector('[data-bys-colour-name]');
        if (name) name.textContent = rec.variant.title;
        var price = card.querySelector('[data-bys-price]');
        if (price) price.textContent = money(rec.variant.price);

        var preorderNote = card.querySelector('[data-bys-preorder]');
        if (preorderNote) {
          preorderNote.textContent = rec.variant.preorder ? rec.variant.preorder.note : '';
          preorderNote.hidden = !preorderNote.textContent;
        }
        var addBtn = card.querySelector('[data-bys-add]');
        if (addBtn) addBtn.disabled = !rec.variant.available;

        closeColours();
        if (toggle) toggle.focus();
      });
    });

    var add = card.querySelector('[data-bys-add]');
    if (add) {
      add.addEventListener('click', function () {
        var vid = card.getAttribute('data-variant-id');
        var rec = variantsById[String(vid)];
        if (!rec || !rec.variant.available) return;

        selections.push({ uid: ++uidSeq, variantId: vid, monogram: null, draft: null });
        render();

        add.classList.add('is-added');
        add.textContent = add.getAttribute('data-label-added');
        clearTimeout(add._t);
        add._t = setTimeout(function () {
          add.classList.remove('is-added');
          add.textContent = add.getAttribute('data-label-add');
        }, 1600);
      });
    }
  });

  /* ================================================================= PANEL */
  function render() {
    renderSub();
    renderTiers();
    renderBlocks();
    renderCta();
  }

  function renderSub() {
    var t = activeTier();
    if (!subEl) return;
    subEl.textContent = t
      ? (cfg.labels.subheading || '').replace('[quantity]', t.quantity).replace('[discount]', t.percent)
      : '';
  }

  function renderTiers() {
    if (!tiersEl) return;
    tiersEl.innerHTML = '';
    var active = activeTier();
    tiers.forEach(function (t) {
      var b = el('button', 'bys-tier', tierLabel(t));
      b.type = 'button';
      b.setAttribute('role', 'tab');
      if (active && active.id === t.id) {
        b.classList.add('is-active');
        b.setAttribute('aria-selected', 'true');
      }
      b.addEventListener('click', function (e) {
        e.stopPropagation();
        pickedTierId = t.id;
        render();
      });
      tiersEl.appendChild(b);
    });
  }

  function progressMessage() {
    var target = pickedTier() || tiers.filter(function (t) {
      return selections.length < parseInt(t.quantity, 10);
    })[0];
    if (!target || selections.length >= Number(target.quantity)) {
      target = tiers.filter(function (t) { return selections.length < Number(t.quantity); })[0];
    }
    if (!target) return '';
    var remaining = Number(target.quantity) - selections.length;
    if (reachedTier() && remaining === 1) return 'Add another piece to unlock ' + target.percent + '% off your set';
    return 'Add ' + remaining + ' more piece' + (remaining === 1 ? '' : 's') + ' to unlock ' + target.percent + '% off your set';
  }

  function renderBlocks() {
    if (!blocksEl) return;
    blocksEl.innerHTML = '';

    selections.forEach(function (sel) {
      var rec = variantsById[String(sel.variantId)];
      if (rec) blocksEl.appendChild(buildBlock(sel, rec));
    });

    var empties = Math.max(0, targetQty() - selections.length);
    for (var i = 0; i < empties; i++) {
      var block = el('div', 'bys-block bys-block--empty');
      var main = el('div', 'bys-block__main');
      main.appendChild(el('div', 'bys-block__ph'));
      var body = el('div', 'bys-block__body');
      body.appendChild(el('span', i === 0 ? 'bys-progress bys-progress--slot' : 'bys-block__title bys-block__title--muted', i === 0 ? progressMessage() : cfg.labels.emptySlot));
      main.appendChild(body);
      block.appendChild(main);
      blocksEl.appendChild(block);
    }
    if (!empties && progressMessage()) blocksEl.appendChild(el('p', 'bys-progress', progressMessage()));
  }

  function buildBlock(sel, rec) {
    var block = el('div', 'bys-block');
    block.setAttribute('data-bys-selection', String(sel.uid));
    var main = el('div', 'bys-block__main');

    var imgWrap = el('div', 'bys-block__img');
    var img = document.createElement('img');
    img.src = rec.variant.image || '';
    img.alt = rec.product.title;
    img.loading = 'lazy';
    imgWrap.appendChild(img);
    main.appendChild(imgWrap);

    var body = el('div', 'bys-block__body');

    var row = el('div', 'bys-block__row');
    row.appendChild(el('span', 'bys-block__title', rec.product.title));
    var remove = el('button', 'bys-block__remove', cfg.labels.remove);
    remove.type = 'button';
    remove.addEventListener('click', function () {
      selections = selections.filter(function (s) { return s.uid !== sel.uid; });
      render();
    });
    body.appendChild(row);

    var variants = (rec.product.variants || []).filter(function (v) { return v.available; });
    var colourList = null;
    if (variants.length > 1) {
      var colourToggle = el('button', 'bys-colour__toggle', rec.variant.title);
      colourToggle.type = 'button';
      colourToggle.setAttribute('aria-label', 'Colour for ' + rec.product.title + ': ' + rec.variant.title);
      colourToggle.setAttribute('aria-expanded', String(openColourUid === sel.uid));
      colourToggle.setAttribute('aria-controls', 'bys-colours-' + sel.uid);
      function focusColour() {
        var fresh = blocksEl.querySelector('[data-bys-selection="' + sel.uid + '"] .bys-colour__toggle');
        if (fresh) fresh.focus({ preventScroll: true });
      }
      colourToggle.addEventListener('click', function (event) {
        event.stopPropagation();
        openColourUid = openColourUid === sel.uid ? null : sel.uid;
        render();
        focusColour();
      });
      body.appendChild(colourToggle);
      if (openColourUid === sel.uid) {
        colourList = el('div', 'bys-dropdown bys-colour__list');
        colourList.id = 'bys-colours-' + sel.uid;
        colourList.setAttribute('role', 'group');
        colourList.setAttribute('aria-label', 'Colours for ' + rec.product.title);
        colourList.addEventListener('click', function (event) { event.stopPropagation(); });
        variants.forEach(function (v) {
          var selected = String(v.id) === String(sel.variantId);
          var option = el('button', 'bys-option' + (selected ? ' is-selected' : ''));
          option.type = 'button';
          option.setAttribute('aria-pressed', String(selected));
          option.setAttribute('data-variant-id', String(v.id));
          var thumb = document.createElement('img');
          thumb.src = v.image || rec.variant.image || '';
          thumb.alt = '';
          thumb.loading = 'lazy';
          option.appendChild(thumb);
          option.appendChild(el('span', null, v.title + (v.preorder ? ' — ' + cfg.labels.preorder : '')));
          option.addEventListener('click', function (event) {
            event.stopPropagation();
            sel.variantId = String(v.id);
            if (sel.monogram) {
              var stillOk = foilsFor(sel.variantId).some(function (f) { return f.title === sel.monogram.foil.title; });
              if (!stillOk || !canMonogram(sel.variantId)) sel.monogram = null;
            }
            sel.draft = null;
            openColourUid = null; openMonoUid = null; openFoilUid = null;
            render();
            focusColour();
          });
          colourList.appendChild(option);
        });
      }
    } else {
      body.appendChild(el('span', 'bys-colour__single', rec.variant.title));
    }
    if (rec.variant.preorder) body.appendChild(el('p', 'bys-preorder', rec.variant.preorder.note));

    main.appendChild(body);
    main.appendChild(remove);
    block.appendChild(main);
    if (colourList) block.appendChild(colourList);

    if (canMonogram(sel.variantId)) block.appendChild(buildMono(sel));
    return block;
  }

  function hardwareFor(variantId) {
    var rec = variantsById[String(variantId)];
    var hardware = rec ? String(rec.variant.hardware || '').trim().toLowerCase() : '';
    return hardware === 'gold' || hardware === 'silver' ? hardware : '';
  }
  function foilMismatch(variantId, foil) {
    var hardware = hardwareFor(variantId);
    return !!(hardware && foil && foil.title.toLowerCase() !== hardware);
  }
  function buildMono(sel) {
    var wrap = el('div', 'bys-mono');
    var isOpen = openMonoUid === sel.uid;
    var rec = variantsById[String(sel.variantId)];
    var hardware = hardwareFor(sel.variantId);
    if (sel.monogram) wrap.classList.add('is-applied');
    function edit(event) {
      event.stopPropagation();
      openMonoUid = isOpen ? null : sel.uid;
      openColourUid = null; openFoilUid = null;
      if (openMonoUid === sel.uid && !sel.draft) {
        sel.draft = { letters: sel.monogram ? sel.monogram.letters : '', foil: sel.monogram ? sel.monogram.foil : null };
      }
      render();
      if (openMonoUid === sel.uid) {
        // Focus during the click so mobile browsers can open the keyboard.
        var panel = document.getElementById('bys-mono-panel-' + sel.uid);
        var input = panel && panel.querySelector('.bys-mono__input');
        if (input) input.focus();
      }
    }
    function removeMonogram() {
      sel.monogram = null; sel.draft = null;
      openMonoUid = null; openFoilUid = null;
      render();
    }
    if (sel.monogram && !isOpen) {
      var summary = el('div', 'bys-mono__summary');
      var details = el('span', 'bys-mono__summary-details');
      details.appendChild(el('span', 'bys-mono__label', 'Monogram: “' + sel.monogram.letters + '” · ' + foilLabel(sel.monogram.foil) + ' foil'));
      var editBtn = el('button', 'bys-mono__edit', 'Edit');
      editBtn.type = 'button'; editBtn.addEventListener('click', edit);
      if (foilMismatch(sel.variantId, sel.monogram.foil)) {
        var mismatch = el('span', 'bys-mono__mismatch', '⚠');
        mismatch.title = 'Selected foil does not match the ' + hardware + ' hardware';
        mismatch.setAttribute('aria-label', mismatch.title);
        details.appendChild(mismatch);
      }
      details.appendChild(editBtn);
      var clearBtn = el('button', 'bys-mono__clear', 'Remove');
      clearBtn.type = 'button'; clearBtn.addEventListener('click', removeMonogram);
      details.appendChild(clearBtn);
      summary.appendChild(details);
      summary.appendChild(el('span', 'bys-mono__summary-price', money(cfg.monogram.price)));
      wrap.appendChild(summary);
      return wrap;
    }
    var toggle = el('button', 'bys-mono__toggle');
    toggle.type = 'button';
    toggle.setAttribute('aria-expanded', String(isOpen));
    toggle.setAttribute('aria-controls', 'bys-mono-panel-' + sel.uid);
    toggle.appendChild(el('span', 'bys-mono__label', (isOpen ? '− ' : '+ ') + cfg.monogram.label));
    toggle.appendChild(el('span', null, money(cfg.monogram.price)));
    toggle.addEventListener('click', edit);
    wrap.appendChild(toggle);
    if (!isOpen) return wrap;
    var draft = sel.draft;
    var panel = el('div', 'bys-mono__panel');
    panel.id = 'bys-mono-panel-' + sel.uid;
    panel.addEventListener('click', function (e) { e.stopPropagation(); });
    panel.appendChild(el('p', 'bys-mono__copy', cfg.monogram.copy));
    var preview = el('div', 'bys-mono__preview');
    var updatePreview = buildLivePreview(preview, rec, draft);
    panel.appendChild(preview);
    var limit = Math.min(3, letterLimit(sel.variantId));
    var input = document.createElement('input');
    input.type = 'text'; input.className = 'bys-mono__input';
    input.maxLength = limit; input.autocomplete = 'off';
    input.setAttribute('aria-label', 'Monogram letters, up to ' + limit + ' letters');
    input.placeholder = 'Add Up to ' + limit + ' Letters';
    input.value = draft.letters;
    panel.appendChild(input);
    var foilWrap = el('div', 'bys-mono__foil');
    foilWrap.setAttribute('role', 'group');
    foilWrap.setAttribute('aria-label', 'Foil colour');
    foilWrap.appendChild(el('span', 'bys-mono__foil-label', 'Foil colour'));
    var choices = el('div', 'bys-mono__foil-buttons');
    var allowed = foilsFor(sel.variantId);
    foilsAll().slice().sort(function (a, b) { return a.title.toLowerCase() === 'gold' ? -1 : 1; }).forEach(function (f) {
      var choice = el('button', 'bys-mono__foil-option');
      choice.type = 'button';
      choice.disabled = !allowed.some(function (a) { return a.title === f.title; });
      choice.setAttribute('aria-pressed', String(!!draft.foil && draft.foil.title === f.title));
      var swatch = el('span', 'bys-foil__swatch');
      swatch.style.backgroundColor = f.colour || 'transparent';
      choice.appendChild(swatch); choice.appendChild(el('span', null, foilLabel(f)));
      if (hardware && f.title.toLowerCase() === hardware) choice.appendChild(el('span', 'bys-mono__recommended', 'Recommended'));
      choice.addEventListener('click', function () {
        draft.foil = f;
        updatePreview();
        updateHardwareMessage();
        choices.querySelectorAll('button').forEach(function (other) { other.setAttribute('aria-pressed', String(other === choice)); });
        applyBtn.disabled = !draft.letters || !draft.foil;
      });
      choices.appendChild(choice);
    });
    foilWrap.appendChild(choices); panel.appendChild(foilWrap);
    var hardwareMessage = el('p', 'bys-mono__hardware-message');
    hardwareMessage.setAttribute('aria-live', 'polite');
    function updateHardwareMessage() {
      hardwareMessage.hidden = !hardware;
      var mismatch = foilMismatch(sel.variantId, draft.foil);
      hardwareMessage.classList.toggle('is-warning', mismatch);
      var recommended = hardware ? hardware.charAt(0).toUpperCase() + hardware.slice(1) : '';
      hardwareMessage.textContent = !hardware ? '' : mismatch
        ? 'Heads up: your ' + rec.variant.title + ' ' + rec.product.title + ' has ' + hardware + " hardware, so " + draft.foil.title.toLowerCase() + " foil won't match. We recommend " + hardware + '.'
        : recommended + ' matches the hardware on your ' + rec.variant.title + ' case.';
    }
    updateHardwareMessage();
    panel.appendChild(hardwareMessage);
    var actions = el('div', 'bys-mono__actions');
    var applyBtn = el('button', 'bys-mono__apply', 'Apply');
    applyBtn.type = 'button'; applyBtn.disabled = !draft.letters || !draft.foil;
    input.addEventListener('input', function () {
      draft.letters = input.value.toUpperCase().replace(/[^A-Z]/g, '').substring(0, limit);
      input.value = draft.letters;
      updatePreview();
      applyBtn.disabled = !draft.letters || !draft.foil;
    });
    applyBtn.addEventListener('click', function () {
      if (!draft.letters || !draft.foil) return;
      sel.monogram = { letters: draft.letters, foil: draft.foil };
      sel.draft = null; openMonoUid = null; openFoilUid = null;
      render();
    });
    actions.appendChild(applyBtn);
    var rm = el('button', 'bys-mono__remove', 'Remove');
    rm.type = 'button'; rm.addEventListener('click', removeMonogram);
    actions.appendChild(rm); panel.appendChild(actions);
    wrap.appendChild(panel);
    return wrap;
  }

  /* ------------------------------------------------------------------- CTA */
  /* One image coordinate plane scales the photograph and foil together.
     These are the existing PDP desktop calibration dimensions; viewport
     breakpoints must never move the initials relative to the patch. */
  var monogramPositions = {
  "39341877231719": {
    "source": "Duo_Vanity_Case_Black_1.png?v=1785246212",
    "x": 260,
    "y": 414
  },
  "51644007776628": {
    "source": "DuoVanityCase_Espresso.png?v=1785245716",
    "x": 257,
    "y": 414
  },
  "53501725737332": {
    "source": "DuoVanityCase_Pebble_a656e916-b851-4479-aab5-fb4a260d56ab.png?v=1785245715",
    "x": 258,
    "y": 410
  },
  "40388523360359": {
    "source": "DuoVanityCase_GingerBrown.png?v=1785245716",
    "x": 259,
    "y": 415
  },
  "40334955184231": {
    "source": "DuoVanityCase_GingerBrown_2.png?v=1785245715",
    "x": 262,
    "y": 410
  },
  "40334987755623": {
    "source": "Duo_Vanity_Case_Burgundy_Lizard_2_b6eff9aa-f18b-4d9a-a073-f394169fc670.png?v=1784384376",
    "x": 257,
    "y": 412
  },
  "40334984872039": {
    "source": "DuoVanityCase_Blush.png?v=1785245716",
    "x": 259,
    "y": 417
  },
  "40334961410151": {
    "source": "DuoVanityCase_Burgundy_1a4ff177-0855-4d9b-8ab3-29626b3430a4.png?v=1785245715",
    "x": 262,
    "y": 411
  },
  "52101413372276": {
    "source": "DuoVanityCase_RobinBlue.png?v=1785245715",
    "x": 257,
    "y": 412
  },
  "53501915529588": {
    "source": "DuoVanityCase_Navy.png?v=1785245715",
    "x": 258,
    "y": 414
  },
  "53869063274868": {
    "source": "DuoVanityCase_Crush.png?v=1785245715",
    "x": 260,
    "y": 414
  },
  "54413792280948": {
    "source": "DuoVanityCase_NoirCroc_7be5679d-156f-443b-b291-3466a77048fe.png?v=1785245715",
    "x": 260,
    "y": 415
  },
  "55220928250228": {
    "source": "DuoVanityCase_Forest_0515f0a9-6902-4e46-a00d-d7850a15b2f2.png?v=1787398163",
    "x": 256,
    "y": 412
  },
  "56129409155444": {
    "source": "Duo_Vanity_Case__Lavender_Pink.png?v=1789724173",
    "x": 260,
    "y": 409
  },
  "56229244273012": {
    "source": "Duo_Vanity_Case__Grey.png?v=1790862849",
    "x": 259,
    "y": 412
  },
  "56229246009716": {
    "source": "Duo_Vanity_Case__Cobalt_af4da022-a36b-4f48-9887-9dec2b443167.png?v=1790862926",
    "x": 260,
    "y": 414
  },
  "39341877592167": {
    "source": "Vanity_Case__Black_7001bf58-2577-4d08-b787-549a340312af.png?v=1785245710",
    "x": 260,
    "y": 418
  },
  "51644012626292": {
    "source": "Vanity_Case__Espresso_b87f0742-8830-4113-b59a-c95316dedd3c.png?v=1785245710",
    "x": 262,
    "y": 415
  },
  "53501834592628": {
    "source": "Vanity_Case__Pebble_1dc4002a-1168-435c-ae55-e743db36cfec.png?v=1785245710",
    "x": 259,
    "y": 414
  },
  "40388533026919": {
    "source": "Vanity_Case__Ginger_Brown_8fb8c1a6-49be-4ac3-ac99-49d7e1f5a53d.png?v=1785245710",
    "x": 262,
    "y": 414
  },
  "40336339894375": {
    "source": "Vanity_Case__Beige.png?v=1785245710",
    "x": 260,
    "y": 412
  },
  "40336365617255": {
    "source": "Vanity_Case__Off_White_fb2d5777-6231-4716-ae15-548afb75e5da.png?v=1785245710",
    "x": 263,
    "y": 416
  },
  "40336369582183": {
    "source": "Vanity_Case__Grey_4b8a74c6-e730-41aa-b0ac-d58a74386de9.png?v=1785245710",
    "x": 260,
    "y": 412
  },
  "40336394420327": {
    "source": "Duo_Vanity_Case_Burgundy_Lizard_3.png?v=1784384955",
    "x": 259,
    "y": 413
  },
  "40336383705191": {
    "source": "Vanity_Case__Blush.png?v=1785245710",
    "x": 260,
    "y": 417
  },
  "40336347431015": {
    "source": "Vanity_Case__Burgundy_f1528dfb-e35b-4a6f-b3b1-448be9aa0d71.png?v=1785245710",
    "x": 262,
    "y": 411
  },
  "52101413994868": {
    "source": "Vanity_Case__Robin_Blue.png?v=1785245710",
    "x": 257,
    "y": 413
  },
  "53501932994932": {
    "source": "Vanity_Case__Navy_23df1b4f-a525-43dc-9c26-93daf178ce62.png?v=1785245710",
    "x": 260,
    "y": 414
  },
  "53869069762932": {
    "source": "Vanity_Case__Crush_6176bbf2-542b-4365-9aa9-511d057f1a9b.png?v=1785245710",
    "x": 262,
    "y": 414
  },
  "54413800964468": {
    "source": "Vanity_Case__Noir_Croc_8f5d3cca-9346-48f7-baf1-4b4dfbeb539c.png?v=1785245709",
    "x": 259,
    "y": 417
  },
  "55220952629620": {
    "source": "VanityCase_Forest.png?v=1787399655",
    "x": 259,
    "y": 412
  },
  "55221036319092": {
    "source": "Vanity_Case__Cobalt.png?v=1787399912",
    "x": 258,
    "y": 413
  },
  "40160804962407": {
    "source": "Mini_Vanity_Case__Black_0a9a0a5d-5252-4f57-8da8-57da418c0f81.png?v=1785245960",
    "x": 257,
    "y": 414
  },
  "51644017115508": {
    "source": "Mini_Vanity_Case__Espresso_e8559919-8e14-4c9e-94a1-f16cd91fc36f.png?v=1785245960",
    "x": 251,
    "y": 410
  },
  "53501876568436": {
    "source": "Mini_Vanity_Case__Pebble_b53ae42a-4ede-4e90-8578-64f809baaad3.png?v=1785245960",
    "x": 257,
    "y": 412
  },
  "40388540989543": {
    "source": "Mini_Vanity_Case__Ginger_Brown_65cb19b4-f8d6-4ced-a1ab-6e17ae3db02c.png?v=1785245960",
    "x": 256,
    "y": 408
  },
  "40336433348711": {
    "source": "Mini_Vanity_Case__Beige.png?v=1785245960",
    "x": 264,
    "y": 415
  },
  "40336472866919": {
    "source": "Mini_Vanity_Case__Off_White_6cbdcf6c-ca63-4dcf-a487-1d32f6476abe.png?v=1785245959",
    "x": 260,
    "y": 412
  },
  "40336457039975": {
    "source": "MiniVanityCase-Grey_c13b5329-bcbc-4018-8542-014280080037.png?v=1761681252",
    "x": 259,
    "y": 411,
    "image": "//etoile.com/cdn/shop/files/Mini_Vanity_Case__Grey_cacd537b-8dc5-4bb5-bacd-b0bb38d50c83.png?v=1785245960&width=900"
  },
  "40336467820647": {
    "source": "Mini_Vanity_Case_Lilac_NEW.png?v=1784385090",
    "x": 264,
    "y": 412
  },
  "40336462643303": {
    "source": "Mini_Vanity_Case__Blush.png?v=1785245959",
    "x": 259,
    "y": 412
  },
  "40336441770087": {
    "source": "Mini_Vanity_Case__Burgundy_e13110a1-0db9-4196-bb04-fadfa0bbf149.png?v=1785245960",
    "x": 255,
    "y": 412
  },
  "52101414027636": {
    "source": "Mini_Vanity_Case__Robin_Blue.png?v=1785245960",
    "x": 258,
    "y": 412
  },
  "53501951377780": {
    "source": "Mini_Vanity_Case__Navy_70815339-a244-40ec-9cf7-11d2b192fe5c.png?v=1785245960",
    "x": 258,
    "y": 413
  },
  "53869026574708": {
    "source": "Mini_Vanity_Case__Crush_375b39ec-c545-4c62-8891-9a95080e6899.png?v=1785245960",
    "x": 257,
    "y": 411
  },
  "54413803815284": {
    "source": "Mini_Vanity_Case__Noir_Croc_65531130-6715-4aca-b05b-a89a9c8e83b6.png?v=1785245960",
    "x": 260,
    "y": 413
  },
  "55221071937908": {
    "source": "MiniVanityCase_Forest.png?v=1787401547",
    "x": 258,
    "y": 411
  },
  "51631282848116": {
    "source": "Oval_Toiletry_Case__Black_5d2c4247-7df5-4061-b653-3920f34265b9.png?v=1785246305",
    "x": 260,
    "y": 423
  },
  "51732673528180": {
    "source": "Oval_Toiletry_Case__Espresso_a23d42b4-dc48-47fb-91a7-5ba804c378e9.png?v=1785246305",
    "x": 264,
    "y": 420
  },
  "53501979263348": {
    "source": "Oval_Toiletry_Case__Pebble_79aa3fb4-8383-4d5d-ab55-2ee7502294e1.png?v=1785246305",
    "x": 260,
    "y": 423
  },
  "51624828043636": {
    "source": "Oval_Toiletry_Case__Ginger_Brown_5fff7fd6-47b5-4f8f-a98a-93f8cfb47583.png?v=1785246305",
    "x": 258,
    "y": 427
  },
  "52104622047604": {
    "source": "Oval_Toiletry_Case__Lavender_Pink_702bf0d8-f07f-4e61-91f0-91bb982a7686.png?v=1785246305",
    "x": 258,
    "y": 422
  },
  "52104622473588": {
    "source": "Oval_Toiletry_Case__Burgundy_0614af1b-0de6-4e84-bb66-68e2bf5c6cd4.png?v=1785246305",
    "x": 258,
    "y": 423
  },
  "52101414060404": {
    "source": "Oval_Toiletry_Case__Robin_Blue.png?v=1785246433",
    "x": 257,
    "y": 412
  },
  "53501943972212": {
    "source": "Oval_Toiletry_Case__Navy_cbaa86c7-0d2f-495e-8e84-ff2d2ba7227c.png?v=1785246305",
    "x": 255,
    "y": 424
  },
  "53868911853940": {
    "source": "Oval_Toiletry_Case__Crush_eaba7fe6-fdf5-4f46-aab8-a89e912a4c67.png?v=1785246305",
    "x": 256,
    "y": 428
  },
  "54413811941748": {
    "source": "Oval_Toiletry_Case__Noir_Croc_240efb5d-5f61-4a82-bb10-8165055ff984.png?v=1785246305",
    "x": 256,
    "y": 423
  },
  "39341878116455": {
    "source": "JetSetterTravelCaseBlack.png?v=1786662901",
    "x": 254,
    "y": 363
  },
  "40334884143207": {
    "source": "JetSetterTravelCase_Beige.png?v=1786361488",
    "x": 260,
    "y": 375
  },
  "40334885978215": {
    "source": "JetSetterTravelCase-OffWhite_2.png?v=1786371336",
    "x": 254,
    "y": 359
  },
  "40334884438119": {
    "source": "JetSetterTravelCase-Grey.png?v=1786371336",
    "x": 264,
    "y": 374
  },
  "40334884307047": {
    "source": "JetSetterTravelCase_Burgundy.png?v=1786371337",
    "x": 263,
    "y": 361
  },
  "40334884339815": {
    "source": "JetSetterTravelCase-Cobalt.png?v=1786371336",
    "x": 250,
    "y": 363
  },
  "40334884372583": {
    "source": "Jet_Setter_Travel_Case__Forest_0467b9cc-9eb4-4ea7-856b-fc486bfa22c3.png?v=1789547651",
    "x": 265,
    "y": 363
  },
  "40334885912679": {
    "source": "JetSetterTravelCase_LavenderPink.png?v=1786371336",
    "x": 257,
    "y": 366
  },
  "40334885945447": {
    "source": "JetSetterTravelCase_Lilac.png?v=1786371336",
    "x": 269,
    "y": 366
  },
  "32945620975719": {
    "source": "Clear_Makeup_Travel_Case__Black_b6ab2701-7437-4875-be5f-bad6a649dafe.png?v=1786733874",
    "x": 257,
    "y": 275
  },
  "40334851702887": {
    "source": "Clear_Makeup_Travel_Case__Beige.png?v=1785247182",
    "x": 258,
    "y": 284
  },
  "40334853898343": {
    "source": "Clear_Makeup_Travel_Case__Burgundy_b470e840-f724-4597-ae8d-32222b7f2393.png?v=1785247183",
    "x": 258,
    "y": 277
  },
  "40334853931111": {
    "source": "Clear_Makeup_Travel_Case__Cobalt.png?v=1785247486",
    "x": 257,
    "y": 280
  },
  "40334853963879": {
    "source": "Clear_Makeup_Travel_Case__Forest.png?v=1786366786",
    "x": 256,
    "y": 277
  },
  "40334853996647": {
    "source": "Clear_Makeup_Travel_Case__Grey_e1d51fa1-9834-42da-8fba-873d18b3bde6.png?v=1785247182",
    "x": 256,
    "y": 278
  },
  "40334854062183": {
    "source": "Clear_Makeup_Travel_Case__Lavender_Pink_Old_6718aee1-cb3f-44e9-a6cf-82507114bb46.png?v=1785247182",
    "x": 258,
    "y": 278
  },
  "40334854160487": {
    "source": "Clear_Makeup_Travel_Case__Lilac.png?v=1785247486",
    "x": 253,
    "y": 286
  },
  "54425234571636": {
    "source": "Clear_Makeup_Travel_Case__Pebble_c6c2f4f5-2365-4d68-8d7a-b7b985664331.png?v=1785247486",
    "x": 263,
    "y": 280
  }
};

  function buildLivePreview(container, rec, draft) {
    var ns = 'http://www.w3.org/2000/svg';
    var data = rec.variant.preview || {};
    var settings = data.settings || {};
    var position = monogramPositions[String(rec.variant.id)];
    var sourceKey = String(data.image || '').split('/').pop().replace(/([?&])width=\d+&?/, '$1').replace(/[?&]$/, '');
    if (position && position.source !== sourceKey) position = null;
    var svg = document.createElementNS(ns, 'svg');
    svg.setAttribute('viewBox', '0 0 516 600');
    svg.setAttribute('class', 'bys-mono__canvas');
    svg.setAttribute('role', 'img');
    var photo = document.createElementNS(ns, 'image');
    photo.setAttribute('href', (position && position.image) || data.image || upscale(rec.variant.image || '', GRID_IMAGE_WIDTH));
    photo.setAttribute('width', '516'); photo.setAttribute('height', '600');
    photo.setAttribute('preserveAspectRatio', 'xMidYMid slice');
    svg.appendChild(photo);
    var lettering = document.createElementNS(ns, 'g');
    lettering.setAttribute('class', 'bys-mono__initials');
    svg.appendChild(lettering); container.appendChild(svg);
    var version = 0;
    function update() {
      var current = ++version;
      lettering.replaceChildren();
      var label = rec.product.title + ' - ' + rec.variant.title;
      svg.setAttribute('aria-label', label);
      var x = Number(settings.horizontal_letter_position);
      var y = Number(settings.vertical_letter_position);
      var w = Number(settings.width_container_desktop);
      var h = Number(settings.height_container_desktop);
      if (!draft.letters || !draft.foil || !cfg.monogram.glyphSample ||
          !Number.isFinite(x) || !Number.isFinite(y) || !(w > 0) || !(h > 0)) return;
      var scale = Number(settings.letter_scale) / 100 || 1;
      var height = 26 * scale;
      var centreX = position ? position.x : (x + w / 2) * 5.16;
      // PDP margin-top percentages resolve against the image width.
      var centreY = position ? position.y : y * 5.16 + h * 3 - 2.5 * scale;
      var base = cfg.monogram.glyphSample.split('/').slice(0, -1).join('/') + '/';
      var prefix = fontName() + '_' + sizeName() + '_' + foilValue(draft.foil) + '_';
      var chars = draft.letters.split('');
      svg.setAttribute('aria-label', label + ', monogram ' + draft.letters + ' in ' + foilLabel(draft.foil) + ' foil');
      var loaded = 0, glyphs = [];
      chars.forEach(function (letter, index) {
        var asset = new Image();
        asset.onload = function () {
          if (current !== version) return;
          glyphs[index] = { url: asset.src, width: height * asset.naturalWidth / asset.naturalHeight };
          if (++loaded !== chars.length) return;
          var total = glyphs.reduce(function (sum, glyph) { return sum + glyph.width; }, 0);
          var left = centreX - total / 2;
          glyphs.forEach(function (glyph) {
            var image = document.createElementNS(ns, 'image');
            image.setAttribute('href', glyph.url);
            image.setAttribute('x', left); image.setAttribute('y', centreY - height / 2);
            image.setAttribute('width', glyph.width); image.setAttribute('height', height);
            lettering.appendChild(image); left += glyph.width;
          });
        };
        asset.src = base + prefix + letter.toLowerCase() + '.png';
      });
    }
    update();
    return update;
  }

  function renderCta() {
    if (!ctaEl) return;
    var ready = !!reachedTier();
    var summary = root.querySelector('[data-bys-subtotal]');
    if (!summary) {
      summary = el('div', 'bys-subtotal');
      summary.setAttribute('data-bys-subtotal', '');
      summary.setAttribute('aria-live', 'polite');
      ctaEl.parentNode.insertBefore(summary, ctaEl);
    }
    summary.hidden = !selections.length;
    summary.innerHTML = '';
    var monoCount = selections.filter(function (s) { return !!s.monogram; }).length;
    var label = 'Subtotal (' + selections.length + ' piece' + (selections.length === 1 ? '' : 's');
    if (monoCount) label += ' · ' + monoCount + ' monogram' + (monoCount === 1 ? '' : 's');
    summary.appendChild(el('span', 'bys-subtotal__label', label + ')'));
    var prices = el('span', 'bys-subtotal__prices');
    if (rrpTotal() > discountedTotal()) prices.appendChild(el('s', 'bys-subtotal__was', money(rrpTotal())));
    prices.appendChild(el('span', 'bys-subtotal__now', money(discountedTotal())));
    summary.appendChild(prices);
    ctaEl.hidden = !ready;
    ctaEl.classList.toggle('is-ready', ready && !submitting);
    ctaEl.disabled = !ready || submitting;
    ctaEl.textContent = submitting ? cfg.labels.ctaBusy : 'Add Set to Cart';
  }

  /* ------------------------------------------------------------------ cart */
  function shopRoot() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }


  // Keep the completed set mounted behind the drawer. Reset only when the
  // customer closes it, so the page cannot collapse during the handoff.
  function showAddedSet(response) {
    var controller = window.cart;
    var timer;
    function stopWaiting() { clearTimeout(timer); }
    function detach() {
      stopWaiting();
      document.removeEventListener('theme:cart:open', stopWaiting);
      document.removeEventListener('theme:cart:close', finish);
    }
    function finish() {
      detach();
      selections = [];
      pickedTierId = null;
      openColourUid = null; openMonoUid = null; openFoilUid = null;
      submitting = false;
      root.inert = false;
      root.removeAttribute('aria-busy');
      render();
    }
    function showCartPage() {
      detach();
      // The add already succeeded. Never retry it if drawer rendering fails.
      window.location.assign(shopRoot() + 'cart');
    }
    if (!controller || typeof controller.getCart !== 'function' ||
        controller.cartDrawerEnabled === false) {
      showCartPage();
      return;
    }
    document.addEventListener('theme:cart:open', stopWaiting);
    document.addEventListener('theme:cart:close', finish);
    if (!controller.isCartDrawerOpen) timer = setTimeout(showCartPage, 12000);
    var html = response.sections && response.sections['api-cart-items'];
    try {
      controller.getCart(true, typeof html === 'string' && html.trim() ? html : null);
    } catch (error) {
      showCartPage();
    }
  }

  if (ctaEl) {
    ctaEl.addEventListener('click', function () {
      if (submitting || !reachedTier()) return;
      submitting = true;
      root.inert = true;
      root.setAttribute('aria-busy', 'true');
      renderCta();

      var setId = 'set-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 7);
      var items = [];

      selections.forEach(function (sel, i) {
        var rec = variantsById[String(sel.variantId)];
        if (!rec) return;
        var index = String(i + 1);

        /* Monogram detail rides on the PRODUCT line so the cart renders it
           the same way the PDP does - see the note at the top of this file. */
        var props = { '_set_id': setId, '_set_index': index };
        if (rec.variant.preorder) props.preorder_date = rec.variant.preorder.property;
        if (sel.monogram) {
          props['Personalisation'] = 'Monogram';
          props['Letters'] = sel.monogram.letters;
          props['Colour'] = foilValue(sel.monogram.foil);
          props['Font'] = fontName();
          props['Size'] = sizeName();
          if (rec.variant.sku) props['SKU'] = rec.variant.sku;
        }

        items.push({ id: Number(sel.variantId), quantity: 1, properties: props });

        /* The charge line is hidden by cart-line-items.liquid (it hides every
           Personalisation-type line). It exists purely to carry the fee. */
        if (sel.monogram && cfg.monogram.variantId) {
          items.push({
            id: Number(cfg.monogram.variantId),
            quantity: 1,
            properties: { '_set_id': setId, '_set_index': index, '_bundle_group': setId }
          });
        }
      });

      fetch(shopRoot() + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: items, sections: 'api-cart-items', sections_url: shopRoot() + 'cart' })
      })
        .then(function (r) {
          if (!r.ok) return r.json().then(function (err) { throw new Error(err.description || r.status); });
          return r.json();
        })
        .then(showAddedSet)
        .catch(function (err) {
          submitting = false;
          root.inert = false;
          root.removeAttribute('aria-busy');
          renderCta();
          console.warn('[BYS] add to cart failed', err);
          alert('Sorry, we could not add your set to the cart. Please try again.');
        });
    });
  }

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape' || !openColourUid) return;
    var uid = openColourUid;
    openColourUid = null;
    render();
    var toggle = blocksEl.querySelector('[data-bys-selection="' + uid + '"] .bys-colour__toggle');
    if (toggle) toggle.focus();
  });

  document.addEventListener('click', function () {
    if (openColourUid || openMonoUid || openFoilUid) {
      openColourUid = null;
      openMonoUid = null;
      openFoilUid = null;
      render();
    }
  });

  render();
})();

